var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.isUserLoggedIn)?_c('v-sheet',{staticClass:"pa-2",attrs:{"rounded":_vm.isSmallerDisplay() ? '' : 'lg'}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',{staticClass:"pa-1"},[_c('iframe',{staticClass:"agreement_iframe",attrs:{"frameBorder":"0","height":"100%","id":"scroll-target","src":_vm.url}})])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }